import React from 'react'

import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Spin as AntSpin } from 'antd'

import { useStyles } from './styles'
import type { SpinProps } from './types'

const DESCRIPTION_STYLE_KEY = {
  small: 'descriptionSmall',
  default: 'descriptionDefault',
  large: 'descriptionLarge'
} as const

export const Spin: React.FC<SpinProps> = ({
  size = 'default',
  showDescription = true,
  description = 'Loading...',
  className,
  style,
  children,
  spinning = true,
  replace = false
}) => {
  const { styles, cx } = useStyles()

  const indicator = <FontAwesomeIcon icon={faSpinnerThird} spin aria-hidden />

  const standaloneSpinner = (
    <div className={cx(styles.root, className)} style={style}>
      <AntSpin size={size} indicator={indicator} />
      {showDescription && (
        <span className={styles[DESCRIPTION_STYLE_KEY[size]]}>
          {description}
        </span>
      )}
    </div>
  )

  if (!children) {
    return standaloneSpinner
  }

  if (replace) {
    return spinning ? standaloneSpinner : <>{children}</>
  }

  // Overlay: `children` stays mounted, dimmed underneath the spinner —
  // antd's own nested pattern, so its `tip` works (unlike the standalone
  // case above, which antd only renders in nested/fullscreen mode).
  return (
    <AntSpin
      spinning={spinning}
      size={size}
      indicator={indicator}
      tip={showDescription ? description : undefined}
      className={cx(styles.overlay, className)}
      style={style}
    >
      {children}
    </AntSpin>
  )
}
